import { render, staticRenderFns } from "./partyAllience.vue?vue&type=template&id=ca3a1ce6&scoped=true"
import script from "./partyAllience.vue?vue&type=script&lang=js"
export * from "./partyAllience.vue?vue&type=script&lang=js"
import style0 from "./partyAllience.vue?vue&type=style&index=0&id=ca3a1ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3a1ce6",
  null
  
)

export default component.exports